import FieldsObject = UniversalAnalytics.FieldsObject;

export function gaEvent(
  category: string,
  action: string,
  label: string,
  value?: number,
) {
  /* Details of arguments:
   * https://support.google.com/analytics/answer/1033068#Anatomy
   *
   * Always use at least category, action and label as those are needed to use any event as a goal
   * in the google analytics console.
   */

  const eventData: FieldsObject = {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  };

  if (value) {
    eventData.eventValue = value;
  }

  if (window.ga) {
    window.ga('send', eventData);
  }
}
